"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isResolvedShorthand", {
    enumerable: true,
    get: ()=>isResolvedShorthand
});
const _react = require("react");
function isResolvedShorthand(shorthand) {
    return shorthand !== null && typeof shorthand === 'object' && !Array.isArray(shorthand) && !/*#__PURE__*/ (0, _react.isValidElement)(shorthand);
} //# sourceMappingURL=isResolvedShorthand.js.map

//# sourceMappingURL=isResolvedShorthand.js.map